import { FunctionComponent, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import Page from 'components/ui/page'
import PageHeader from 'components/ui/pageHeader'
import EmptyState from 'components/ui/emptyState'
import { hasActiveBi } from 'features/doctors/types'
import * as userApi from 'features/user/api.client'
import styles from './style.module.scss'

const BiMedico: FunctionComponent = () => {
  const [urlBi, setUrlBi] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadUrl = async () => {
      try {
        const user = await userApi.get()
        setUrlBi(hasActiveBi(user) ? user.urlBi || null : null)
      } finally {
        setLoading(false)
      }
    }

    loadUrl()
  }, [])

  return (
    <Page>
      <PageHeader title="Bi Médico" />

      {loading && (
        <div className="card d-flex align-items-center justify-content-center p-5">
          <Spinner animation="border" size="sm" />
        </div>
      )}

      {!loading && !urlBi && (
        <EmptyState
          icon={<Icon name="chart" size={20} />}
          title="Bi Médico não disponível"
          description="O painel ainda não foi habilitado para a sua conta."
        />
      )}

      {!loading && urlBi && (
        <div className={`card ${styles.biFrameWrap}`}>
          <iframe
            title="Bi Médico"
            src={urlBi}
            className={styles.biFrame}
            allowFullScreen
          />
          <div className={styles.biBrandCover} aria-hidden="true" />
        </div>
      )}
    </Page>
  )
}

export default BiMedico
